module.exports = __webpack_public_path__ + "img/gb937.asm.f0634c22.jpg";